<div class="message message-warning">
  <%= I18n.insurance.callouts.no_insurance.replaceAll('%{provider_phone_number}', provider.phone_number) %>
</div>
